import { useContext, useEffect } from "react";
import AuthContext from "contexts/AuthContext";
import { Outlet, useLocation } from "react-router-dom";
import Intercom from "@intercom/messenger-js-sdk";
import { INTERCOM_ARGS, END_OF_PILOT_25_ARGS } from "consts/feature-config";
import useWhen from "hooks/useWhen";

export default function IntercomProvider() {
  // After the end of the pilot, support is email-only: leave Intercom
  // unbooted so mailto contact links work natively and no bubble renders
  const endOfPilot25 = useWhen(END_OF_PILOT_25_ARGS);
  const showIntercom = useWhen(INTERCOM_ARGS) && !endOfPilot25;
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const pathname = location.pathname;
  const isKiosk = pathname.includes("en-US/kiosk");
  const isStoreorWarehouse =
    pathname.includes("en-US/store") || pathname.includes("/warehouse");
  const admin_user = Boolean(
    user?.email &&
      (user.email.endsWith("lego.com") || user.email.endsWith("pentatonic.com"))
  );

  // Initialize Intercom once on mount
  useEffect(() => {
    if (showIntercom) {
      Intercom({
        app_id: "ged8p9l8",
        custom_launcher_selector: ".my_custom_launcher",
      });
    }
  }, [showIntercom]);

  useEffect(() => {
    if (showIntercom && user) {
      Intercom("shutdown");
      Intercom("boot");
    }
  }, [showIntercom, user]);

  useEffect(() => {
    if (showIntercom) {
      if (user) {
        window.intercomSettings = {
          app_id: "ged8p9l8",
          custom_launcher_selector: ".my_custom_launcher",
          ...(user?.email && {
            email: user.email,
            name: user.first_name,
            user_first_name: user.first_name,
            admin_user: admin_user,
          }),
          ...(isStoreorWarehouse || isKiosk
            ? { hide_default_launcher: true }
            : {}),
        };
      } else {
        window.intercomSettings = {
          app_id: "ged8p9l8",
          custom_launcher_selector: ".my_custom_launcher",
          ...(isStoreorWarehouse || isKiosk
            ? { hide_default_launcher: true }
            : {}),
        };
      }
    }
  }, [showIntercom, user, admin_user, isStoreorWarehouse, isKiosk]);

  return <Outlet />;
}
